module.exports = {
  "/verify/:token": {
    "name": "verifyRoute",
    "success": {
      "Verify page load": [
        "VERIFY_LOAD"
      ]
    },
    "error": [
      "VERIFY_ERROR"
    ]
  },
  "/preview": {
    "name": "previewRoute",
    "success": {
      "Preview page load": [
        "PREVIEW_LOAD"
      ]
    }
  },
  "/:urlSlug": {
    "name": "indexRoute",
    "success": {
      "Page load": [
        "INDEX_LOAD"
      ]
    }
  },
  "/": {
    "name": "missingSlugRoute",
    "success": {
      "missing slug page load": [
        "MISSING_SLUG_LOAD"
      ]
    }
  }
};